import React, { useState, useRef, useEffect } from 'react'
import './FaqStatic.css'

function FaqStatic() {
  const [activeIndex, setActiveIndex] = useState(null);
  const faqRefs = useRef([]);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
    
    // Scroll to the clicked question with offset for header
    setTimeout(() => {
      if (faqRefs.current[index]) {
        const headerOffset = 120; // Adjust this value based on your header height + some padding
        const elementPosition = faqRefs.current[index].getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  useEffect(() => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
  }, []);

  const faqData = [
    {
      question: "How can I log in to my FWFG account?",
      answer: (
        <>
          <p><strong>Android/iOS App:</strong></p>
          <ul>
            <li>Open the app.</li>
            <li>Tap on the "Account" tab.</li>
            <li>A popup will appear. Click on "Sign In".</li>
            <li>You will be redirected to the "login screen" to enter your credentials. On the login screen, you will see various options:</li>
            <ul>
              <li>Email/Password: Enter your registered email and password.</li>
              <li>Email me a login link: Enter your registered email to receive a login link.</li>
              <li>Social Media Login: Sign in using your Apple or Google accounts.</li>
            </ul>
          </ul>
          <p><strong>Website:</strong></p>
          <ul>
            <li>Visit <a href="https://fwfg.com/login" target="_blank" rel="noopener noreferrer">https://fwfg.com/login</a>.</li>
            <li>On the login screen, you will see various options:</li>
            <ul>
              <li>Email/Password: Enter your registered email and password.</li>
              <li>Sign in via Email: Enter your registered email to receive a login link.</li>
            </ul>
          </ul>
          <p><strong>TV:</strong></p>
          <ul>
            <li>Open the app.</li>
            <li>Tap on the "Account" tab.</li>
            <li>On the login screen, you will see various options:</li>
            <ul>
              <li>QR Code Login: Scan the QR code displayed on the TV screen using your mobile device.</li>
              <li>Activation Code: Enter the activation code on the website as instructed.</li>
              <li>Sign In using email: This will redirect you to the following options:</li>
              <ul>
                <li>Login via Email: Use your registered email to receive a login link.</li>
                <li>Login via Email and Password: Enter your email and password directly on the TV screen.</li>
              </ul>
            </ul>
          </ul>
        </>
      )
    },
    {
      question: "How to reset your password?",
      answer: (
        <>
          <p><strong>Website:</strong></p>
          <ul>
            <li>Visit <a href="https://fwfg.com/forgot-password" target="_blank" rel="noopener noreferrer">https://fwfg.com/forgot-password</a>.</li>
            <li>Enter your registered email address.</li>
            <li>Check your email inbox for a reset password link.</li>
            <li>Click the link and follow the instructions to set a new password.</li>
          </ul>
          <p><strong>iOS/Android App:</strong></p>
          <ul>
            <li>Open the app and click on the Login option.</li>
            <li>Tap on Forgot Password.</li>
            <li>Enter your registered email address.</li>
            <li>Check your email inbox for a reset password link.</li>
            <li>Follow the link to reset your password.</li>
          </ul>
          <p><strong>TV:</strong></p>
          <ul>
            <li>Open the app and navigate to the "Login" screen.</li>
            <li>Click on Forgot Password.</li>
            <li>Enter your registered email address.</li>
            <li>Check your email inbox for a reset password link.</li>
            <li>Follow the link to reset your password.</li>
          </ul>
        </>
      )
    },
    {
      question: "How do I purchase a subscription?",
      answer: (
        <>
          <p><strong>Website:</strong></p>
          <p>For new users (not registered):</p>
          <ul>
            <li>Visit <a href="https://fwfg.com/checkout" target="_blank" rel="noopener noreferrer">https://fwfg.com/checkout</a>.</li>
            <li>Enter your email and create a password.</li>
            <li>Choose your preferred subscription plan.</li>
            <li>Click on Continue to complete the process.</li>
          </ul>
          <p>For logged-in users:</p>
          <ul>
            <li>Visit <a href="https://fwfg.com" target="_blank" rel="noopener noreferrer">https://fwfg.com</a>.</li>
            <li>Click on your profile menu at the top-right corner then from the dropdown, select “Subscribe”.</li>
            <li>Select your subscription plan and proceed with the payment to activate your subscription.</li>
          </ul>
          <p><strong>iOS / Android:</strong></p>
          <ul>
            <li>Open the FWFG app.</li>
            <li>Click on any content. This will redirect you to the details screen for that content.</li>
            <li>Click on the Watch Now button. This will open the subscription list screen.</li>
            <li>Choose your preferred subscription plan and click Continue to proceed with the payment and activate your subscription.</li>
          </ul>
          <p><strong>TV:</strong></p>
          <ul>
            <li>Open the FWFG app.</li>
            <li>Click on any content. This will redirect you to the details screen for that content.</li>
            <li>Click on the Watch Now button. This will open the subscription list screen.</li>
            <li>Choose your preferred subscription plan to proceed with the payment and activate your subscription.</li>
          </ul>
        </>
      )
    },
    {
      question: "How do I contact customer support?",
      answer: (
        <>
          <p>You can contact customer support through the following methods:</p>
          <p><strong>Website:</strong></p>
          <ul>
            <li>Visit <a href="https://fwfg.com/contact-support" target="_blank" rel="noopener noreferrer">https://fwfg.com/contact-support</a>.</li>
          </ul>
          <p><strong>Android/iPhone App:</strong></p>
          <ul>
            <li>Open the FWFG app.</li>
            <li>Navigate to the Account tab.</li>
            <li>Click on Contact Us.</li>
            <li>Tap on the support email to send your query via email.</li>
          </ul>
        </>
      )
    },
    {
      question: "Where can I see my billing history?",
      answer: (
        <>
          <p>You can view your billing or transaction history on our website:</p>
          <ul>
            <li>Visit <a href="https://fwfg.com/account/billing-activity" target="_blank" rel="noopener noreferrer">https://fwfg.com/account/billing-activity</a>, where you can review all your past purchases.</li>
          </ul>
          <p><strong>Having subscription issues?</strong> If you've already subscribed but are experiencing issues, please contact us here and provide the requested information. We'll assist you in resolving the issue.</p>
        </>
      )
    },
    {
      question: "What should I do if I signed in via Apple and opted to hide my email?",
      answer: (
        <>
          <p>If you signed in using your Apple ID and chose the "Hide My Email" option, you may face issues recovering your account if you forget your credentials.</p>
          <p>To avoid this, we highly recommend updating your account details:</p>
          <p><strong>Website:</strong></p>
          <ul>
            <li>Visit <a href="https://fwfg.com/settings" target="_blank" rel="noopener noreferrer">https://fwfg.com/settings</a>.</li>
            <li>Click on the "Set Password" option.</li>
            <li>You will be redirected to <a href="https://fwfg.com/set-password" target="_blank" rel="noopener noreferrer">https://fwfg.com/set-password</a>.</li>
            <li>Enter your email address and create a new password.</li>
            <li>Click the "Save Changes" button to update your credential.</li>
          </ul>
          <p><strong>iOS / Android:</strong></p>
          <ul>
            <li>Log in to your account.</li>
            <li>Navigate to the "Account" tab.</li>
            <li>Click on "Set Password".</li>
            <li>Update your email address and set password.</li>
          </ul>
          <p>This ensures you can easily recover your account in case you forget your credentials.</p>
        </>
      )
    },
    {
      question: "How do I change my password?",
      answer: (
        <>
          <p><strong>Website:</strong></p>
          <ul>
            <li>Visit <a href="https://fwfg.com/account" target="_blank" rel="noopener noreferrer">https://fwfg.com/account</a>.</li>
            <li>Click on the "Change Password" button.</li>
            <li>You will be redirected to <a href="https://fwfg.com/change-password" target="_blank" rel="noopener noreferrer">https://fwfg.com/change-password</a>.</li>
            <li>Enter your current password and the new password.</li>
            <li>Click on the "Save Changes" button to update your password.</li>
          </ul>
          <p><strong>On iOS/Android/TV:</strong> In the app, you can only reset your password. To do so:</p>
          <ul>
            <li>Tap on "Forgot Password" on the login screen.</li>
            <li>Follow the steps to reset your password via your registered email.</li>
          </ul>
        </>
      )
    },
    {
      question: "How do I log out of all devices?",
      answer: (
        <>
          <p>This feature gives you complete control over your account and its access shared with other members of the family.</p>
          <p><strong>Website:</strong></p>
          <ul>
            <li>Visit <a href="https://fwfg.com/account" target="_blank" rel="noopener noreferrer">https://fwfg.com/account</a>.</li>
            <li>Scroll down and click on "Sign out of all devices".</li>
            <li>Confirm by clicking OK on the popup.</li>
          </ul>
          <p><strong>On iOS/Android and other TV platforms:</strong></p>
          <p>If the device limit for your purchased plan is exceeded, you will receive a popup notification in the app when you click on the "Watch Now" button to access content.</p>
          <ul>
            <li>In the popup, click "Logout all" to log out from all connected devices.</li>
            <li>After logging out, users with connected devices will no longer be able to watch content until they log in again.</li>
          </ul>
        </>
      )
    },
    {
      question: "How can I log in to the app from my TV via QR code?",
      answer: (
        <>
          <p>To log in via QR code on the TV app, follow these steps:</p>
          <ul>
            <li>Open the FWFG app on your TV.</li>
            <li>Click on the "Account" tab.</li>
            <li>Scan the QR code displayed on the TV screen using your mobile device.</li>
            <li>This will redirect you to the TV activation link in your mobile browser.</li>
            <ul>
              <li>If you're already logged in to our website, you will be directed to the TV activation screen.</li>
              <li>If you're not logged in, you will be prompted to log in first, then redirected to the TV activation screen.</li>
            </ul>
            <li>Click Activate to complete the login process.</li>
          </ul>
        </>
      )
    }
  ];



  return (
    <div className="faq-container">
      <h1 className="faq-header">Frequently Asked Questions</h1>

      {faqData.map((faq, index) => (
        <div 
          key={index} 
          className="faq-item"
          ref={el => faqRefs.current[index] = el}
        >
          <h3 
            className={`faq-question ${activeIndex === index ? 'active' : ''}`}
            onClick={() => toggleFaq(index)}
          >
            {faq.question}
          </h3>
          <div className={`faq-content ${activeIndex !== index ? 'hidden' : ''}`}>
            {faq.answer}
          </div>
        </div>
      ))}
    </div>
  );
}

export default FaqStatic